
      
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/components/partial-dictionary-autocomplete/assets/dictionary-translations.lang.json', {"rootName":{"ru_RU":"Верхний уровень справочника","en_US":"The top level of the directory"}}) 
    }
   
      
      export default "src/components/partial-dictionary-autocomplete/assets/dictionary-translations.lang.json"
    